import { all, call, put, takeLatest } from "redux-saga/effects";

import { ToastContent, getToastContent } from "constants/toasts";
import { ApiManager } from "services/api";
import { CannedResponsesSerializer } from "services/api/canned-responses";
import { CRUDAction, RequestAction } from "store/entities/actions";
import { INTEGRATION } from "store/entities/integrations";
import { ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";

import { CANNED_RESPONSE, CannedResponseActionNames, CannedResponseActions } from "./actions";
import { ALL_TEAMS_ID } from "./constants";
import {
  ICreateCannedResponsePayload,
  IDeleteCannedResponseAttachmentPayload,
  IDeleteCannedResponsePayload,
  IFetchSinglePayload,
  IUpdateCannedResponsePayload,
} from "./interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchSingle(action: IActionWithPayload<string, IFetchSinglePayload>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.cannedResponsesApi.fetch, id);
  if (response.result) {
    yield put(
      CannedResponseActions.fetchSuccess({ id, value: CannedResponsesSerializer.deserialize(response.result) })
    );
  } else {
    yield put(CannedResponseActions.fetchFailure({ id, error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchCollection() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.cannedResponsesApi.fetchAll);

  if (response.result) {
    yield put(
      CannedResponseActions.fetchCollectionSuccess({
        values: CannedResponsesSerializer.deserializeList(response.result),
      })
    );
  } else {
    yield put(CannedResponseActions.fetchCollectionFailure({ error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* create(action: IActionWithPayload<string, ICreateCannedResponsePayload>) {
  const { richTextObj, shortcuts, transactionId } = action.payload.value;
  let { teamId } = action.payload.value;
  if (teamId === ALL_TEAMS_ID) {
    // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | un... Remove this comment to see the full error message
    teamId = null;
  }
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.cannedResponsesApi.create, { teamId, richTextObj, shortcuts, transactionId });

  if (response.result) {
    const cannedResponse = CannedResponsesSerializer.deserialize(response.result);
    yield put(CannedResponseActions.createSuccess({ id: cannedResponse.id, value: cannedResponse }));
  } else {
    yield put(CannedResponseActions.createFailure({ error: response.error.error }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* update(action: IActionWithPayload<string, IUpdateCannedResponsePayload>) {
  const { id, richTextObj, shortcuts, transactionId } = action.payload.value;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.cannedResponsesApi.update, { id, richTextObj, shortcuts, transactionId });

  if (response.result) {
    const cannedResponse = CannedResponsesSerializer.deserialize(response.result);
    yield put(CannedResponseActions.updateSuccess({ id: cannedResponse.id, value: cannedResponse }));
  } else {
    // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    yield put(CannedResponseActions.updateFailure({ id, error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteCannedResponse(action: IActionWithPayload<string, IDeleteCannedResponsePayload>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.cannedResponsesApi.deleteCannedResponse, id);

  if (response.result) {
    yield put(CannedResponseActions.deleteSuccess({ id }));
  } else {
    yield put(CannedResponseActions.deleteFailure({ id }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteCannedResponseAttachment(action: IActionWithPayload<string, IDeleteCannedResponseAttachmentPayload>) {
  const { id, attachmentIndex } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.cannedResponsesApi.deleteCannedResponseAttachment, id, attachmentIndex);

  if (response.result) {
    yield put(
      ToastsActions.createToast({
        variant: ToastVariant.Success,
        content: getToastContent(ToastContent.ATTACHMENT_DELETE_SUCCESS),
      })
    );
  } else {
    yield put(
      ToastsActions.createToast({
        variant: ToastVariant.Error,
        content: getToastContent(ToastContent.ATTACHMENT_DELETE_FAILURE),
      })
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* cannedResponsesSagas() {
  yield all([
    takeLatest(CANNED_RESPONSE[CRUDAction.FETCH_SINGLE][RequestAction.REQUEST], fetchSingle),
    takeLatest(
      [
        CANNED_RESPONSE[CRUDAction.FETCH_COLLECTION][RequestAction.REQUEST],
        INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_FINISHED,
      ],
      fetchCollection
    ),
    takeLatest(CANNED_RESPONSE[CRUDAction.CREATE][RequestAction.REQUEST], create),
    takeLatest(CANNED_RESPONSE[CRUDAction.UPDATE][RequestAction.REQUEST], update),
    takeLatest(CANNED_RESPONSE[CRUDAction.DELETE][RequestAction.REQUEST], deleteCannedResponse),
    takeLatest(CannedResponseActionNames.REMOVE_ATTACHMENT, deleteCannedResponseAttachment),
  ]);
}
